import React, { useEffect, useRef, useState } from "react";
import "./Home.scss";
import banner1 from "../../assets/Home/Raer_Poster_02.webp";
import banner2 from "../../assets/Home/Raer_Poster_03.webp";
import banner3 from "../../assets/Home/Raer_Poster_06.webp";
import banner5 from "../../assets/Home/Raer_Poster_04.webp";
import banner6 from "../../assets/homePage/Raer_Poster_07.webp";
import banner7 from "../../assets/Home/Raer_Poster_08.webp";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { newcolor } from "../../constants/color";
import LikeItem from "../../components/LikeItem/LikeItem";

const banners = [banner2, banner3, banner5];

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", right: 0 }}
      onClick={onClick}
    />
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        left: 0,
        zIndex: 1,
      }}
      onClick={onClick}
    />
  );
};

const Home = () => {
  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");
  const carouselRef = useRef(null);

  const handleWheel = (e) => {
    e.preventDefault();
    const delay = 500;

    if (e.deltaY < 0) {
      setTimeout(() => {
        carouselRef.current.next();
      }, delay);
    } else {
      setTimeout(() => {
        carouselRef.current.prev();
      }, delay);
    }
  };
  //done
  const navigate = useNavigate();
  const [randomProduct, setRandomProduct] = useState([]);
  const [recommended, setRecommended] = useState([]);
  const [bestSellingProduct, setBestSellingProduct] = useState([]);
  const [topProduct, setTopProduct] = useState([]);
  const [whichProductNeedToShow, setWhichProductNeedToShow] = useState(1);

  const getAllProduct = (page = 1, limit = 20) => {
    const config = {
      url: `${process.env.REACT_APP_BASE_URL}api/allProducts/null?page=${page}&limit=${limit}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          const shuffleData = shuffleArray(response.data.data);
          console.log(shuffleData);
          setRandomProduct(shuffleData);
          setRecommended(
            getRandomProducts(shuffleArray(response.data.data), 6)
          );
          setTopProduct(shuffleData);

          console.log("->>>>>>>>", topProduct);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };
  const sliderSettings = {
    // infinite: true,
    slidesToShow: 4, // Show two slides, one full and one partial
    slidesToShow: 4, // Show two slides, one full and one partial
    slidesToScroll: 1,
    // prevArrow: <PrevArrow />,
    centerPadding: "30%",
    // nextArrow: <NextArrow />,
    arrows: true,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          centerPadding: "30%", // On smaller screens, show a smaller part of the next image
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
          centerPadding: "15%", // On smaller screens, show a smaller part of the next image
        },
      },
      // {
      //   breakpoint: 700,
      //   settings: {
      //     slidesToShow: 1,
      //     slidesToScroll: 1,
      //     infinite: true,
      //     centerPadding: "30%", // On smaller screens, show a smaller part of the next image
      //   },
      // },
      {
        breakpoint: 670,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          centerPadding: "8%", // On smaller screens, show a smaller part of the next image
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
        },
      },
      // {
      //   breakpoint: 300,
      //   settings: {
      //     slidesToShow: 1,
      //     slidesToScroll: 1,
      //     infinite: true,
      //     centerPadding: "5%", // On smaller screens, show a smaller part of the next image
      //   },
      // },
    ],
  };

  const whatWeMakeSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const getBestSellingProduct = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getMostBuyProduct`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status) {
          setBestSellingProduct(response?.data?.data);
          console.log(bestSellingProduct);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const getRandomProducts = (array, count) => {
    const shuffledArray = shuffleArray(array);
    const selectedProducts = [];

    for (let i = 0; i < count; i++) {
      selectedProducts.push(shuffledArray[i]);
    }

    return selectedProducts;
  };

  const shuffleArray = (array) => {
    return array.sort(() => Math.random() - 0.5);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setWhichProductNeedToShow(
        (prevIndex) => (prevIndex + 1) % topProduct.length
      );
      console.log("->>>.", whichProductNeedToShow);
    }, 5000);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [topProduct.length]);

  useEffect(() => {
    getAllProduct();
    getBestSellingProduct();
  }, []);

  const settingsHome = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    // nextArrow: <NextArrow />,
    // prevArrow: <PrevArrow />,
    autoplay: true,
    autoplaySpeed: 4700,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 530,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    autoplay: true,
    autoplaySpeed: 4700,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 530,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  const [activeIndex, setActiveIndex] = useState(0);

  const handleScroll = () => {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;

    const newIndex = Math.min(
      Math.floor(scrollY / windowHeight),
      banners.length - 1
    );
    setActiveIndex(newIndex);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  console.log(banners);

  return (
    <>
      <div class="home-main container-fluid">
        {/* products slider carousel */}
        {/* <div class="text-center container-5">
          <div class="row inner-divs" style={{ background: "#B2A08E" }}>
            <Slider {...settings}>
              {randomProduct?.map((product, index) => (
                <div className="productFirstDiv">
                  <div key={index} className=" mx-0 aaa">
                    <img
                      src={product?.image[0]}
                      alt={product?.name}
                      style={{ objectFit: "cover", cursor: "pointer" }}
                      onClick={() => setWhichProductNeedToShow(index)}
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div> */}

        {/* <div className="HomeBanner">
          <Slider {...settingsHome}>
            <div className="subItem">
              <div className="item" onClick={() => navigate("/shop/null")}>
                <img src={banner1} alt="" className="logo-img " />
              </div>
            </div>
           
            <div className="subItem">
              <div className="item" onClick={() => navigate("/shop/null")}>
                <img src={banner3} alt="" className="logo-img " />
              </div>
            </div>
            <div className="subItem">
              <div className="item" onClick={() => navigate("/shop/null")}>
                <img src={banner4} alt="" className="logo-img " />
              </div>
            </div>
          </Slider>
        </div> */}

        <div className="home-banner">
          <div
            className="imgssss"
            onClick={() => {
              navigate("/allProduct");
              window.scrollTo(0, 0);
            }}
          >
            <img src={banner6} alt="" useMap="work" />
            <map name="work"></map>
            <area shape="rect" coords="1241" href="" alt="" />
          </div>
          <div
            className="img"
            onClick={() => {
              navigate("/allProduct");
              window.scrollTo(0, 0);
            }}
          >
            <img src={banner7} alt="" />
          </div>
          <div className="shoopal text-center mt-5">
            <button
              onClick={() => {
                navigate("/allProduct");
                window.scrollTo(0, 0);
              }}
              type="button"
              class="btn btn-dark"
            >
              Shop Now
            </button>
          </div>
        </div>

        {/* single product details carousel */}
        {/* <div className="container-fluid home-container-1">
          <div class="row">
            <div
              id="carouselExampleDark"
              className="carousel carousel-dark slide"
            >
              <div class="cardss">
                <div class="row inner-card mt-3">
                  <div class="col-lg-6 col-md-6 col-sm-6 topClassForImg ">
                    <div className="img-div">
                      <img
                        className="Homeimg"
                        src={topProduct[whichProductNeedToShow]?.image[0]}
                        alt="..."
                      />
                    </div>
                  </div>done

                  <div class="col-lg-6 col-md-6 col-sm-6 left-img-details">
                    <div class="card-body">
                      <h1
                        class="card-title"
                        style={{ fontSize: "3rem", fontWeight: "700" }}
                      >
                        {
                          topProduct[whichProductNeedToShow]?.categoryId
                            .categoryName
                        }
                      </h1>

                      <h1
                        class="card-title"
                        style={{
                          fontSize: "2.5rem",
                          fontWeight: "700",
                          color: "#806040",
                        }}
                      >
                        {topProduct[whichProductNeedToShow]?.productName}
                      </h1>

                      <div>
                        <p className="discription">
                          {" "}
                          {topProduct[whichProductNeedToShow]?.description[0]}
                        </p>
                      </div>

                      <div className="row price-div align-items-center justify-content-center">
                        <div className="col-12 priceDiv">
                          <p className="">
                            {" "}
                            Color: {topProduct[whichProductNeedToShow]?.color}
                          </p>
                        </div>

                        <div className="col-12 priceDiv">
                          <p>
                            {" "}
                            Rs. {topProduct[whichProductNeedToShow]?.price}/-
                          </p>
                        </div>
                      </div>

                      <div className="button">
                        <button
                          className="shop-Button"
                          style={{
                            // backgroundColor: "#332C1F",
                            background: newcolor.background,
                            color: "white",
                            border: "none",
                            padding: "1rem 3rem",
                            fontWeight: "500",
                            borderRadius: "9px",
                            fontSize: "1rem",
                          }}
                          onClick={() =>
                            navigate(
                              `/product/${topProduct[whichProductNeedToShow]?._id}`
                            )
                          }
                        >
                          SHOP NOW
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* What we make heading */}
        <div className="container mt-5 text-center home-container-2">
          <div class="row">
            <h1 style={{ fontSize: "60px" }}>WHAT WE MAKE</h1>

            <div class="d-flex gap-1 justify-content-center align-items-center subheading-div">
              {/* left circle */}
              <div
                className="small-circle"
                style={{
                  border: "1px solid #aaa",
                  width: "1%",
                  height: "45%",
                  borderRadius: "80px",
                }}
              ></div>

              <hr className="w-25 small-line" />
              <h5>RECOMMENDED PRODUCTS</h5>
              <hr className="w-25 small-line" />

              {/* right circle */}
              <div
                className="small-circle"
                style={{
                  border: "1px solid #aaa",
                  width: "1%",
                  height: "45%",
                  borderRadius: "80px",
                }}
              ></div>
            </div>
          </div>
        </div>

        {/* What we make content */}
        <div className="main-div mt-5 ">
          {/* default rendering of what we make content */}
          <div className="card-outer">
            {" "}
            {/* card-1 */}
            <div
              className="my-cards"
              onClick={() => {
                navigate(`/product/${recommended[0]?._id}`);
                window.scrollTo(0, 0);
              }}
            >
              <div className="div-img">
                <img
                  src={recommended[0]?.image[0]}
                  alt="shirt"
                  class="card-img-top"
                  // style={{ objectFit: "cover", margin: "0", height: "50%" }}
                />
              </div>

              <div className="info">
                <div className="left-info">
                  <h5 class="card-title">{recommended[0]?.productName}</h5>
                  <h5 class="card-text">
                    Rs.{" "}
                    <span className="bg-color">
                      {Math.ceil(recommended[0]?.price || 0)}/-
                    </span>{" "}
                    &nbsp;
                    <del>{recommended[0]?.higherPrice}/-</del>
                  </h5>
                </div>

                <div className="right-info">
                  <i
                    class="bi bi-plus-lg text-dark fs-3"
                    onClick={() => {
                      navigate(`/product/${recommended[0]?._id}`);
                      window.scrollTo(0, 0);
                    }}
                  ></i>
                </div>
              </div>
            </div>
            {/* card-2 */}
            <div
              className="my-cards"
              onClick={() => {
                navigate(`/product/${recommended[2]?._id}`);
                window.scrollTo(0, 0);
              }}
            >
              <div className="div-img">
                <img
                  src={recommended[2]?.image[0]}
                  alt="shirt"
                  class="card-img-top"
                />
              </div>
              <div className="info">
                <div className="left-info">
                  <h5 class="card-title">{recommended[2]?.productName}</h5>
                  <h5 class="card-text ">
                    Rs.{" "}
                    <span className="bg-color">
                      {Math.ceil(recommended[2]?.price || 0)}/-
                    </span>{" "}
                    <del>{recommended[2]?.higherPrice}/-</del>
                  </h5>
                </div>
                <div className="right-info">
                  <i
                    class="bi bi-plus-lg text-dark fs-3"
                    onClick={() => {
                      navigate(`/product/${recommended[2]?._id}`);
                      window.scrollTo(0, 0);
                    }}
                  ></i>
                </div>
              </div>
            </div>
            {/* card-3 */}
            <div
              className="my-cards"
              onClick={() => {
                navigate(`/product/${recommended[1]?._id}`);
                window.scrollTo(0, 0);
              }}
            >
              <div className="div-img">
                <img
                  src={recommended[1]?.image[0]}
                  alt="shirt"
                  class="card-img-top"
                />
              </div>
              <div className="info">
                <div className="left-info">
                  <h5 class="card-title">{recommended[1]?.productName}</h5>
                  <h5 class="card-text">
                    Rs.{" "}
                    <span className="bg-color">
                      {Math.ceil(recommended[1]?.price || 0)}/-
                    </span>{" "}
                    <del>{recommended[1]?.higherPrice}/-</del>
                  </h5>
                </div>
                <div className="right-info">
                  <i
                    class="bi bi-plus-lg text-dark fs-3"
                    onClick={() => {
                      navigate(`/product/${recommended[1]?._id}`);
                      window.scrollTo(0, 0);
                    }}
                  ></i>
                </div>
              </div>
            </div>
            {/* card-4 */}
            <div
              className="my-cards"
              onClick={() => {
                navigate(`/product/${recommended[3]?._id}`);
                window.scrollTo(0, 0);
              }}
            >
              <div className="div-img">
                <img
                  src={recommended[3]?.image[0]}
                  alt="shirt"
                  class="card-img-top"
                />
              </div>
              <div className="info">
                <div className="left-info">
                  <h5 class="card-title">{recommended[3]?.productName}</h5>
                  <h5 class="card-text">
                    Rs.{" "}
                    <span className="bg-color">
                      {Math.ceil(recommended[3]?.price || 0)}/-
                    </span>{" "}
                    <del>{recommended[3]?.higherPrice}/-</del>
                  </h5>
                </div>
                <div className="right-info">
                  <i
                    class="bi bi-plus-lg text-dark fs-3"
                    onClick={() => {
                      navigate(`/product/${recommended[3]?._id}`);
                      window.scrollTo(0, 0);
                    }}
                  ></i>
                </div>
              </div>
            </div>
            {/* card-5 */}
            <div
              className="my-cards"
              onClick={() => {
                navigate(`/product/${recommended[4]?._id}`);
                window.scrollTo(0, 0);
              }}
            >
              <div className="div-img">
                <img
                  src={recommended[4]?.image[0]}
                  alt="shirt"
                  class="card-img-top"
                />
              </div>
              <div className="info">
                <div className="left-info">
                  <h5 class="card-title">{recommended[4]?.productName}</h5>
                  <h5 class="card-text">
                    Rs.{" "}
                    <span className="bg-color">
                      {Math.ceil(recommended[4]?.price || 0)}/-
                    </span>{" "}
                    <del>{recommended[4]?.higherPrice}/-</del>
                  </h5>
                </div>
                <div className="right-info">
                  <i
                    class="bi bi-plus-lg text-dark fs-3"
                    onClick={() => {
                      navigate(`/product/${recommended[4]?._id}`);
                      window.scrollTo(0, 0);
                    }}
                  ></i>
                </div>
              </div>
            </div>
            {/* card-6 */}
            <div
              className="my-cards"
              onClick={() => {
                navigate(`/product/${recommended[5]?._id}`);
                window.scrollTo(0, 0);
              }}
            >
              <div className="div-img">
                <img
                  src={recommended[5]?.image[0]}
                  alt="shirt"
                  class="card-img-top"
                />
              </div>
              <div className="info">
                <div className="left-info">
                  <h5 class="card-title">{recommended[5]?.productName}</h5>
                  <h5 class="card-text">
                    Rs.{" "}
                    <span className="bg-color">
                      {Math.ceil(recommended[5]?.price || 0)}/-
                    </span>{" "}
                    <del>{recommended[5]?.higherPrice}/-</del>
                  </h5>
                </div>
                <div className="right-info">
                  <i
                    class="bi bi-plus-lg text-dark fs-3"
                    onClick={() => {
                      navigate(`/product/${recommended[5]?._id}`);
                      window.scrollTo(0, 0);
                    }}
                  ></i>
                </div>
              </div>
            </div>
          </div>

          {/* conditional rendering for mobile of what we make content carousel width less than 500px */}
          <div className="row justify-content-center slider-card-div ">
            <Slider {...whatWeMakeSliderSettings}>
              {recommended.map((product) => (
                <div key={product._id} className="slider-card-div-inner">
                  <div className="slider-card-img-div">
                    <img
                      src={product?.image[0]}
                      alt="shirt"
                      className="slider-card-img"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate(`/product/${product?._id}`);
                        window.scrollTo(0, 0);
                      }}
                    />
                  </div>

                  <div className="info">
                    <div className="left-info">
                      <h5 class="card-title">{product?.productName}</h5>
                      <p class="card-text">
                        {/* Rs. <span className="bg-color">{product?.price}/-</span>{" "} */}
                        <b>Rs. {Math.ceil(product?.price || 0)}/-</b> &nbsp;
                        &nbsp;
                        <del>{product?.higherPrice}/-</del>
                      </p>
                    </div>

                    <div className="right-info">
                      <i
                        class="bi bi-plus-lg text-dark fs-3"
                        onClick={() => {
                          navigate(`/product/${product?._id}`);
                          window.scrollTo(0, 0);
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          {/* for the mobile width */}
          <div className="container product-card-conn mt-5">
            <div className="inner-card-divv">
              {recommended.map((product) => (
                <div key={product._id} className=" home-cards-col22 ">
                  <div className=" home-card-main222 shadow ">
                    <div className="img-div-1 ">
                      <img
                        src={product?.image[0]}
                        alt="shirt"
                        className="card-img-top"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          navigate(`/product/${product?._id}`);
                          window.scrollTo(0, 0);
                        }}
                      />
                      <div className="likeee">
                        <LikeItem
                          productIDdd={product?._id}
                          IsLikedIte={product?.like?.some(
                            (like) => like._id === userId
                          )}
                        />
                      </div>
                    </div>

                    <div className="card-body" style={{ textAlign: "start" }}>
                      <div>
                        <h6 className="card-title">
                          {product?.productName.length > 15
                            ? `${product.productName.substring(0, 15)}...`
                            : product.productName}
                        </h6>
                        <h6 className="card-text">
                          <b>Rs. {Math.ceil(product?.price || 0)}/-</b>
                          <del>{product?.higherPrice}/-</del>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/*Best Seller */}
        <div className=" text-center home-container-3 ">
          <div class="row best-seller-heading">
            <div className="row">
              <h1 style={{ fontSize: "60px" }}>BEST SELLER</h1>

              <div class="d-flex gap-1 justify-content-center align-items-center subheading-div">
                {/* left circle */}
                <div
                  className="small-circle"
                  style={{
                    border: "1px solid #aaa",
                    width: "1%",
                    height: "45%",
                    borderRadius: "80px",
                  }}
                ></div>

                <hr className="w-25 small-line" />
                <h5>BEST PRODUCTS FOR YOU</h5>
                <hr className="w-25 small-line" />

                {/* right circle */}
                <div
                  className="small-circle"
                  style={{
                    border: "1px solid #aaa",
                    width: "1%",
                    height: "45%",
                    borderRadius: "80px",
                  }}
                ></div>
              </div>
            </div>
          </div>

          {/* product-cards */}
          <div className="container product-card-con mt-5 text-center">
            <div className=" justify-content-center inner-card-div">
              <Slider {...sliderSettings}>
                {bestSellingProduct.map((product) => (
                  <div
                    key={product._id}
                    className=" home-cards-col2 align-items-center"
                  >
                    <div className="card home-card-main2  ">
                      <div className="img-div-1 ">
                        <img
                          src={product?.image[0]}
                          alt="shirt"
                          className="card-img-top"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate(`/product/${product?._id}`);
                            window.scrollTo(0, 0);
                          }}
                        />
                        <LikeItem
                          productIDdd={product?._id}
                          IsLikedIte={product?.like?.some(
                            (like) => like._id === userId
                          )}
                        />
                      </div>

                      <div className="card-body" style={{ textAlign: "start" }}>
                        <div>
                          <h6 className="card-title">{product?.productName}</h6>
                          <h6 className="card-text">
                            {/* <b>Rs. {product?.price}/-</b> &nbsp; &nbsp;
                            <del>
                              Rs.{" "}
                              {product?.price +
                                Math.floor(Math.random() * (500 - 300 + 1)) +
                                300}
                            </del> */}
                            <b>Rs. {Math.ceil(product?.price || 0)}/-</b>{" "}
                            &nbsp;&nbsp;
                            <del>{product?.higherPrice}/-</del>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          {/* for the mobile width */}
          <div className="container product-card-conn mt-5">
            <div className="inner-card-divv">
              {bestSellingProduct.map((product) => (
                <div key={product._id} className=" home-cards-col22 ">
                  <div className=" home-card-main222 shadow ">
                    <div className="img-div-1 ">
                      <img
                        src={product?.image[0]}    
                        alt="shirt"
                        className="card-img-top"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          navigate(`/product/${product?._id}`);
                          window.scrollTo(0, 0);
                        }}
                      />
                      <div className="likeee">
                        <LikeItem
                          productIDdd={product?._id}
                          IsLikedIte={product?.like?.some(
                            (like) => like._id === userId
                          )}
                        />
                      </div>
                    </div>

                    <div className="card-body" style={{ textAlign: "start" }}>
                      <div>
                        <h6 className="card-title">
                          {product?.productName.length > 15
                            ? `${product.productName.substring(0, 19)}...`
                            : product.productName}
                        </h6>
                        <h6 className="card-text">
                          <b>Rs. {Math.ceil(product?.price || 0)}/-</b>
                          <del>{product?.higherPrice}/-</del>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
